"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var FileuploadIcon = function FileuploadIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "icon/file-upload"), /*#__PURE__*/React.createElement("g", {
    id: "icon/file-upload",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wenjianleixing-biaozhuntu-wenjianjia",
    opacity: "0.513044085",
    transform: "translate(79.000000, 142.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,43.9510234 C0,20.0509816 19.374812,0.676169591 43.2748538,0.676169591 L339.301901,0.676169591 C356.613203,0.676169591 372.258411,10.9942143 379.076901,26.9061404 L400.292398,76.4071637 L822.222222,76.4071637 C846.122264,76.4071637 865.497076,95.7819757 865.497076,119.682018 L865.497076,574.067982 C865.497076,597.968024 846.122264,617.342836 822.222222,617.342836 L43.2748538,617.342836 C19.374812,617.342836 0,597.968024 0,574.067982 L0,43.9510234 Z",
    id: "\u8DEF\u5F84",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.005848,146.728801 L746.491228,146.728801 C775.341131,146.728801 789.766082,161.153752 789.766082,190.003655 L789.766082,579.477339 C789.766082,608.327242 775.341131,622.752193 746.491228,622.752193 L119.005848,622.752193 C90.1559454,622.752193 75.7309942,608.327242 75.7309942,579.477339 L75.7309942,190.003655 C75.7309942,161.153752 90.1559454,146.728801 119.005848,146.728801 Z",
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2748538,217.050439 L822.222222,217.050439 C851.072125,217.050439 865.497076,231.47539 865.497076,260.325292 L865.497076,693.07383 C865.497076,721.923733 851.072125,736.348684 822.222222,736.348684 L43.2748538,736.348684 C14.4249513,736.348684 -6.1497266e-14,721.923733 -6.1497266e-14,693.07383 L-6.1497266e-14,260.325292 C-6.1497266e-14,231.47539 14.4249513,217.050439 43.2748538,217.050439 Z",
    id: "\u8DEF\u5F84",
    fill: "#FFCA28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.230308,142 C430.081479,142 443.710156,150.22807 450.627037,163.370143 L479.379,218 L904,218 C926.09139,218 944,235.90861 944,258 L944,697 C944,719.09139 926.09139,737 904,737 L119,737 C96.90861,737 79,719.09139 79,697 L79,258 C79,257.329489 79.0164979,256.662832 79.0491098,256.000411 L79,256 L79,182 C79,159.90861 96.90861,142 119,142 L415.230308,142 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#FFE27A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#FFFFFF",
    x: "155",
    y: "288",
    width: "713",
    height: "145",
    rx: "40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#FFEEA3",
    x: "79",
    y: "359",
    width: "865",
    height: "519",
    rx: "40"
  })));
};
var _default = FileuploadIcon;
exports["default"] = _default;